import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import EventEmitter from 'eventemitter3';
import React, { Component } from 'react';
import getDisplayName from '../utils/get-display-name';
import { throttle as throttleRaf } from '../utils/raf';
var events = new EventEmitter();
var handlers;

function createHandlers() {
  return {
    scroll: {
      handler: throttleRaf(function (e) {
        events.emit('scroll', e);
      }),
      capture: true
    },
    resize: {
      handler: throttleRaf(function (e) {
        events.emit('resize', e);
      })
    },
    click: {
      handler: function handler(e) {
        events.emit('click', e);
      },
      capture: true
    },
    mousedown: {
      handler: function handler(e) {
        events.emit('mousedown', e);
      },
      capture: true
    },
    touchstart: {
      handler: function handler(e) {
        events.emit('touchstart', e);
      },
      capture: true
    }
  };
}

export default function windowEvents() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  return function (OriginalComponent) {
    var _class, _temp;

    return _temp = _class = /*#__PURE__*/function (_Component) {
      _inherits(WrappedComponent, _Component);

      var _super = _createSuper(WrappedComponent);

      function WrappedComponent() {
        _classCallCheck(this, WrappedComponent);

        return _super.apply(this, arguments);
      }

      _createClass(WrappedComponent, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          handlers = handlers || createHandlers();
          types.forEach(function (type) {
            if (!handlers[type].listenersCount) {
              handlers[type].listenersCount = 0;
              window.addEventListener(type, handlers[type].handler, handlers[type].capture);
            }

            handlers[type].listenersCount++;
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          types.forEach(function (type) {
            handlers[type].listenersCount--;
            if (!handlers[type].listenersCount) window.removeEventListener(type, handlers[type].handler, handlers[type].capture);
          });
        }
      }, {
        key: "render",
        value: function render() {
          return React.createElement(OriginalComponent, _extends({}, this.props, {
            windowEvents: events
          }));
        }
      }]);

      return WrappedComponent;
    }(Component), _class.displayName = "windowEvents(".concat(getDisplayName(OriginalComponent), ")"), _temp;
  };
}